/**
 * Enum-like object for CTA tag types.
 *
 * @type {{ Default: CTATagType, Button: CTATagType, Link: CTATagType }}
 * Description: Mapping from CTA tag keys to their string literal values.
 */
export const CTATag = {
  Default: 'Default',
  Button: 'Button',
  Link: 'Link',
};

/**
 * String enum for CTA icon positions (runtime).
 * Values match CTAIconPositionType = 'before' | 'after' | 'link'
 *
 * @type {CTAIconPositionTypes}
 */
export const CTAIconPosition = {
  Before: 'before',
  After: 'after',
  Link: 'link',
};
